export interface GALogEntry {
  timestamp: string;
  event: string;
  params: Record<string, any>;
}

const entries: GALogEntry[] = [];
let active = false;

export function gaLoggerRecord(eventName: string, params?: Record<string, any>): void {
  if (!active) return;
  entries.push({
    timestamp: new Date().toISOString(),
    event: eventName,
    params: params ?? {},
  });
}

export function startGALogger(): void {
  if (typeof window === 'undefined') return;

  active = true;
  (window as any).__gaLog = entries;

  (window as any).exportGALog = (format: 'json' | 'csv' = 'json') => {
    if (!entries.length) {
      console.warn('[GA Logger] Nenhum evento registrado ainda.');
      return;
    }

    let content: string;
    let filename: string;
    let mimeType: string;

    if (format === 'csv') {
      const allParamKeys = Array.from(
        new Set(entries.flatMap((e) => Object.keys(e.params)))
      );
      const headers = ['timestamp', 'event', ...allParamKeys].join(',');
      const rows = entries.map((e) => {
        const base = [`"${e.timestamp}"`, `"${e.event}"`];
        const paramCols = allParamKeys.map((k) => {
          const val = e.params[k] ?? '';
          return `"${String(val).replace(/"/g, '""')}"`;
        });
        return [...base, ...paramCols].join(',');
      });
      content = [headers, ...rows].join('\n');
      filename = `ga-events-${Date.now()}.csv`;
      mimeType = 'text/csv';
    } else {
      content = JSON.stringify(entries, null, 2);
      filename = `ga-events-${Date.now()}.json`;
      mimeType = 'application/json';
    }

    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);

    console.log(`[GA Logger] Exportado ${entries.length} evento(s) → ${filename}`);
  };

  (window as any).clearGALog = () => {
    entries.length = 0;
    console.log('[GA Logger] Log limpo.');
  };

  (window as any).showGALog = () => {
    if (!entries.length) {
      console.warn('[GA Logger] Nenhum evento ainda.');
      return;
    }
    console.table(entries);
  };

  console.log(
    '%c[GA Logger] Ativo — capturando eventos do FirebaseHelper.\n' +
    '  window.showGALog()        → ver eventos no console\n' +
    '  window.exportGALog()      → baixar JSON\n' +
    '  window.exportGALog("csv") → baixar CSV\n' +
    '  window.clearGALog()       → limpar\n' +
    '  window.__gaLog            → array bruto',
    'color: #4CAF50; font-weight: bold'
  );
}
